import { useCallback, useLayoutEffect, useMemo, useState } from "react";
import styles from "./EmailOtpHome.module.scss";
import {
	AuthMethods,
	EmailOtpSteps,
	forwardEmailQueueStatus,
	IIntegrationPartner,
	integrationAuthFormFields,
	ipEmailClients,
	IpNames,
	JobType,
	OtpDeliveryOptions,
	UserRole,
} from "../../../interfaces/interfaces";
import EmailOtpHeader from "./EmailOtpHeader";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import OtpStepInfo from "./OtpStepInfo";
import { PasswordForm } from "../IpScreen/PasswordForm/PasswordForm";
import EmailOtpGifSteps, { emailOtpStepInfo } from "./emailOtpHelper";
import { useAppDispatch, useAppSelector } from "../../../redux/reduxHooks";
import { updateForwardEmailQueue } from "../../../redux/credentialVerification/credentialVerification";
import EmailForwardValidation from "./EmailForwardValidation";
import { IpRestS } from "../../../rest/ipRest-service";
import OtpConfirmation from "./OtpConfimation";
import { RestS } from "../../../rest/rest-service";
import { MultiOTPSelectionForm, setRPAValidationObj } from "./MultiOTPSelection";
import MobileOTPContactMerito from "./MobileOTPContactMerito.module";
import { CheckForwardingEmailSet } from "./CheckForwardingEmailSet";
import { getLocalUser } from "../../../components/functions/utilities";

type Props = {
	ip: IIntegrationPartner;
	setIp: (value: IIntegrationPartner) => void;
	setStep: (value: number) => void;
	handleModalToggle: () => void;
	setSelectedIp: (value: IIntegrationPartner) => void;
	setSuccess: (value: boolean) => void;
};

const emailClientGifSteps = {
	[ipEmailClients.gmail]: new Set([2, 3, 5, 6]),
	[ipEmailClients.outlook]: new Set([2, 3, 4]),
	[ipEmailClients.others]: new Set([2]),
};

const EmailOtpHome = ({ ip, setIp, setStep, handleModalToggle, setSelectedIp, setSuccess }: Props) => {
	const [emailOtpSteps, setEmailOtpSteps] = useState({
		previousStep: 0,
		currentStep: 0,
	});

	const currentUser = getLocalUser();
	const { currentClient } = useAppSelector((state) => state.agencyConfig);

	useLayoutEffect(() => {
		if (ip?.authMethod == AuthMethods.email_otp_password) {
			setEmailOtpSteps({
				previousStep: EmailOtpSteps.multiOtpSelection,
				currentStep: EmailOtpSteps.multiOtpSelection,
			});
		}
	}, [ip]);

	const [formValues, setFormValues] = useState<{
		email: string;
		password: string;
		emailClient: string;
		otpOption: string;
	}>({
		email: "",
		password: "",
		emailClient: "",
		otpOption: ""
	});
	const dispatch = useAppDispatch();

	const handelBack = () => {
		if (ip?.authMethod == AuthMethods.email_otp_password) {
			if (emailOtpSteps?.currentStep == 0) {
				// setEmailOtpSteps(10);
				setEmailOtpSteps(prev => ({
					previousStep: prev?.currentStep,
					currentStep: EmailOtpSteps.multiOtpSelection
				}));
				return;
			}
			if (emailOtpSteps?.currentStep == 1) {
				// console.log('formValues', formValues);
				setFormValues({
					...formValues,
					email: "",
					password: "",
					emailClient: "",
				})
				if (formValues?.otpOption == OtpDeliveryOptions.Email) {
					// setEmailOtpSteps(0);
					setEmailOtpSteps(prev => ({
						previousStep: prev?.currentStep,
						currentStep: EmailOtpSteps.otpInstructions
					}));
					return;
				} else {
					// setEmailOtpSteps(10);
					setEmailOtpSteps(prev => ({
						previousStep: prev?.currentStep,
						currentStep: EmailOtpSteps.multiOtpSelection
					}));
					return;
				}
			}
		}
		if (emailOtpSteps?.currentStep == 7 && formValues?.emailClient == ipEmailClients.outlook) {
			// setEmailOtpSteps(4);
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: EmailOtpSteps.emailForwardValidation
			}));
			return;
		}
		if (emailOtpSteps?.currentStep == 7 && formValues?.emailClient == ipEmailClients.others) {
			// setEmailOtpSteps(2);
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: EmailOtpSteps.emailForwardGif1
			}));
			return;
		}
		// if (emailOtpSteps == 10 && ip?.companyName == IpNames.flipkartSeller) {
		// 	setEmailOtpSteps(0);
		// 	return;
		// }
		if (emailOtpSteps?.currentStep == EmailOtpSteps.multiOtpSelection) {
			setStep(1);
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: EmailOtpSteps.emailForwardGif1
			}));
		}

		if (emailOtpSteps?.currentStep == EmailOtpSteps?.gmailFilterGif1 && formValues?.emailClient == ipEmailClients.gmail) {
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: EmailOtpSteps.checkForwardingAlreadySet
			}));
			return;
		} else if (emailOtpSteps?.currentStep == EmailOtpSteps?.emailForwardGif1 && formValues?.emailClient == ipEmailClients.gmail) {
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: EmailOtpSteps.checkForwardingAlreadySet
			}));
		} else if (emailOtpSteps?.currentStep == EmailOtpSteps.otpInstructions) {
			setStep(1);
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: EmailOtpSteps.credential
			}));
		} else if (emailOtpSteps?.currentStep == EmailOtpSteps.contactMeritoMobileOtp) {
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: EmailOtpSteps.multiOtpSelection
			}));
		} else {
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: prev?.currentStep - 1
			}));
		}
	};

	const checkAndSendForEmailForwarding = async () => {
		console.log("checking for email forwarding");
		dispatch(
			updateForwardEmailQueue({
				email: formValues?.email,
				jobDetails: {
					status: forwardEmailQueueStatus.inProgress,
					emailClient: formValues?.emailClient,
					error: null,
				},
			})
		);
		try {
			// check to send for email forwarding
			const data: any = await RestS.checkIfEmailForwarded(formValues?.email);

			if (data?.isEmailForwarded) {
				// setEmailOtpSteps(5);
				setEmailOtpSteps(prev => ({
					previousStep: prev?.currentStep,
					currentStep: EmailOtpSteps.gmailFilterGif1
				}));

				dispatch(
					updateForwardEmailQueue({
						email: formValues?.email,
						jobDetails: {
							status: forwardEmailQueueStatus.success,
							emailClient: formValues?.emailClient,
							error: null,
						},
					})
				);
				return;
			} else {
				// 1st check if email forwarding already setup
				setEmailOtpSteps(prev => ({
					previousStep: prev?.currentStep,
					currentStep: prev?.currentStep + 1
				}));
				// send to rpa for email forwarding
				IpRestS.connectViaPasswordForm({
					email: formValues?.email,
					password: formValues?.password,
					integrationPartner: ip,
					agencyClientId: currentUser?.role === UserRole.Agency ? currentClient?.id : null,
					extraDetails: {
						jobType: JobType.emailForwardConfirmation,
					}
				});
			}
		} catch (error) {
			console.log("error in sending for email forwarding", error);
		}
	};

	const otpSteps = new Set([AuthMethods.email_otp, AuthMethods.email_otp_password]);

	const handleNext = async (formValuesFromParam = null) => {
		// console.log("emailOtpSteps", emailOtpSteps);
		// console.log('formvalues in next button', formValuesFromParam);

		if (emailOtpSteps?.currentStep == EmailOtpSteps.multiOtpSelection) {
			// console.log('formValues', formValuesFromParam);
			if (formValuesFromParam?.otpOption == OtpDeliveryOptions.Email) {
				console.log('setting step to 0');
				setEmailOtpSteps(prev => ({
					previousStep: prev?.currentStep,
					currentStep: EmailOtpSteps.otpInstructions
				}));
			} else if (formValuesFromParam?.otpOption == OtpDeliveryOptions.Mobile) {
				console.log('setting step to 11');
				setEmailOtpSteps(prev => ({
					previousStep: prev?.currentStep,
					currentStep: EmailOtpSteps.contactMeritoMobileOtp
				}));

			} else {
				setEmailOtpSteps(prev => ({
					previousStep: prev?.currentStep,
					currentStep: EmailOtpSteps.credential
				}));
			}
			return;
		} else if (emailOtpSteps?.currentStep == EmailOtpSteps.credential && formValuesFromParam?.otpOption == OtpDeliveryOptions.NoOtp) {
			// console.log('coming inside this')
			setIp({
				...ip,
				authMethod: AuthMethods.password
			})
			setStep(9);
			IpRestS.connectViaPasswordForm({
				email: formValuesFromParam?.email,
				password: formValuesFromParam?.password,
				agencyClientId: currentUser?.role === UserRole.Agency ? currentClient?.id : null,
				integrationPartner: {
					...ip,
					authMethod: AuthMethods.password
				}
			});
			setRPAValidationObj();
			return;
		} else if (emailOtpSteps?.currentStep == 3 && formValues?.emailClient == ipEmailClients.gmail) {
			await checkAndSendForEmailForwarding();
			return;
		} else if (emailOtpSteps?.currentStep == 4 && formValues?.emailClient == ipEmailClients.outlook) {
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: EmailOtpSteps.emailForwardUserConfirmation
			}));
			return;
		} else if (emailOtpSteps?.currentStep == 2 && formValues?.emailClient == ipEmailClients.others) {
			// setEmailOtpSteps(7);
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: EmailOtpSteps.emailForwardUserConfirmation
			}));
			return;
		} else if (emailOtpSteps?.currentStep == 1 && otpSteps.has(ip?.authMethod as AuthMethods) && formValuesFromParam?.emailClient == ipEmailClients.gmail) {
			// setEmailOtpSteps(12);
			setEmailOtpSteps(prev => ({
				previousStep: prev?.currentStep,
				currentStep: EmailOtpSteps.checkForwardingAlreadySet
			}));
			return;
		}
		setEmailOtpSteps(prev => ({
			previousStep: prev?.currentStep,
			currentStep: prev?.currentStep + 1
		}));

	};


	// const hideBackButtonSteps = new Set([5]);

	const gifSteps = emailClientGifSteps[formValues?.emailClient] ?? new Set();

	const hideButtonSteps = useMemo(() => {
		const steps = formValues?.emailClient == ipEmailClients?.gmail ? new Set([4]) : new Set();
		// if (ip?.companyName == IpNames.flipkartSeller) {
		// 	steps.add(0);
		// }
		steps.add(12);
		return steps;
	}, [formValues, ip]);

	// console.log('hideButtonSteps', hideButtonSteps);

	const hideNextButtonSteps = useMemo(() => {
		const steps = new Set([1, 7]);;
		if ([IpNames.flipkartSeller, IpNames.zepto].includes(ip?.companyName as IpNames)) {
			steps.add(10);
			steps.add(11);
		}
		return steps;
	}, [ip]);

	const hideBackButtonSteps = useMemo(() => {
		const steps = new Set();
		// if(ip?.authMethod == AuthMethods.email_otp_password) {
		// 	steps.
		// }
		return steps;
	}, [ip])


	// console.log('submitted form values', formValues);

	const showFields = useMemo(() => {
		if (ip?.authMethod == AuthMethods.email_otp) {
			return new Set([integrationAuthFormFields.email, integrationAuthFormFields.emailClient]);
		} else if (ip?.authMethod == AuthMethods.email_otp_password) {
			const defaultFields = new Set([integrationAuthFormFields.email]);
			if (formValues?.otpOption == OtpDeliveryOptions.Email) {
				defaultFields.add(integrationAuthFormFields.password);
				defaultFields.add(integrationAuthFormFields.emailClient);
			}
			if (formValues?.otpOption == OtpDeliveryOptions.NoOtp) {
				defaultFields.add(integrationAuthFormFields.password);
			}
			return defaultFields;
		}
	}, [formValues?.otpOption, ip]);


	return (
		<div className={styles.rootContainer}>
			<EmailOtpHeader
				formValues={formValues}
				handleModalToggle={handleModalToggle}
				ip={ip}
				emailOtpStep={emailOtpSteps}
			/>
			<div className={styles.bodyContainer}>
				{emailOtpSteps?.currentStep === EmailOtpSteps.otpInstructions ? (
					<OtpStepInfo ip={ip} />
				) : emailOtpSteps?.currentStep == EmailOtpSteps.credential ? (
					<div className={styles.credentialsStepWrapper}>
						<PasswordForm
							ip={ip}
							showHeader={true}
							setStep={() => {}}
							isNestedStep={true}
							showFields={showFields}
							showTnC={false}
							handleFormSubmit={(values) => {
								setFormValues(values);
								handleNext(values);
							}}
							initialValues={formValues}
							setSelectedIp={setSelectedIp}
							setSuccess={setSuccess}
						/>
					</div>
				) : gifSteps.has(emailOtpSteps?.currentStep) ? (
					<EmailOtpGifSteps
						ip={ip}
						stepInfo={
							emailOtpStepInfo(ip)[formValues?.emailClient][
								emailOtpSteps?.currentStep
							]
						}
					/>
				) : emailOtpSteps?.currentStep == EmailOtpSteps.emailForwardValidation ? (
					<EmailForwardValidation
						ip={ip}
						emailOtpSteps={emailOtpSteps}
						formDetails={formValues}
						setEmailOtpSteps={setEmailOtpSteps}
					/>
				) : emailOtpSteps?.currentStep == 7 ? (
					<OtpConfirmation
						ip={ip}
						setEmailOtpSteps={setEmailOtpSteps}
						emailOtpSteps={emailOtpSteps}
						setStep={setStep}
						formValues={formValues}
						setSelectedIp={setSelectedIp}
						setSuccess={setSuccess}
					/>
				) : emailOtpSteps?.currentStep === 10 ? (
					<div className={styles.credentialsStepWrapper}>
						<MultiOTPSelectionForm
							ip={ip}
							showHeader={true}
							setStep={setEmailOtpSteps}
							showFields={new Set([integrationAuthFormFields.otpOption])}
							handleFormSubmit={(values) => {
								setFormValues(values);
								handleNext(values);
							}}
							initialValues={formValues}
						/>
					</div>
				) : emailOtpSteps?.currentStep == 11 ? (
					<MobileOTPContactMerito selectedIp={ip} />
				) : emailOtpSteps?.currentStep == 12 ? (
					<CheckForwardingEmailSet setStep={setEmailOtpSteps} />
				) : null}
			</div>
			{hideButtonSteps?.has(emailOtpSteps?.currentStep) ? null : (
				<div className={styles.footer}>
					{hideBackButtonSteps.has(emailOtpSteps?.currentStep) ? (
						<div></div>
					) : (
						<MeritoButton
							type="secondary-2"
							btnText="Back"
							onClick={handelBack}
							isRounded={true}
							size="lg"
						/>
					)}
					{hideNextButtonSteps?.has(emailOtpSteps?.currentStep) ? null : (
						<MeritoButton
							type="primary-1"
							btnText="Next"
							onClick={handleNext}
							isRounded={true}
							size="lg"
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default EmailOtpHome;
